import { useQuery } from '@apollo/client/react';

import { usePusherHandler } from '@/hooks/usePusherHandler';

import { graphql } from '@/gql';

import { Or2IntercomProvider } from '../Intercom/Or2IntercomProvider';

import { MainMenu } from './MainMenu';

const MENU_QUERY = graphql(`
  query Menu {
    currentUser {
      _id
      firstName
      lastName
      profileImage
      image
      email
      ...intercomUserHashFragment
    }
  }
`);

interface Props {
  smallScreenDrawerOpen: boolean;
  largeScreenDrawerOpen: boolean;
  onToggleDrawer: () => void;
  children: React.ReactNode;
}

export const MenuEntry = ({
  smallScreenDrawerOpen,
  largeScreenDrawerOpen,
  onToggleDrawer,
  children,
}: Props) => {
  const { data, refetch, loading: requestLoading } = useQuery(MENU_QUERY);

  const user = data?.currentUser;
  const userId = user?._id;

  usePusherHandler(
    userId ? [`object-${userId}`] : null,
    'object-updated',
    refetch,
  );

  const baseUserImage = user?.profileImage || user?.image;

  const menuUser = user ? { ...user, baseImage: baseUserImage } : null;

  const loading = requestLoading && !menuUser;

  return (
    <Or2IntercomProvider intercomUser={menuUser}>
      <MainMenu
        smallScreenDrawerOpen={smallScreenDrawerOpen}
        largeScreenDrawerOpen={largeScreenDrawerOpen}
        onToggleDrawer={onToggleDrawer}
        user={menuUser}
        onSignout={async () => {
          const response = await fetch('/logout', { method: 'POST' });
          const data = await response.json();

          if (data.impersonationRemoved) {
            window.location.href = window.location.origin;
          } else {
            window.location.href = data.logoutUrl;
          }
        }}
        loading={loading}
      >
        {children}
      </MainMenu>
    </Or2IntercomProvider>
  );
};
